import Trasporto from "../../model/Trasporto.js";
import Oneri from "../../model/Oneri.js";
import Accisa from "../../model/Accisa.js";
import AddizionaleRegionale from "../../model/AddizionaleRegionale.js";
import Iva from "../../model/Iva.js";

class Gas {
    
    g = 0.289;                      //- prezzo materia prima --- per la link c'è un prezzo ad hoc
    qvd = {                         //- componente di commercializzazione ---
        fisso: 90,                  //- canone ---     
        variabile: 0                // 0.007946
    }
    scaglioni = [
        0, 120, 480, 1560, 5000, 80000
    ] 
    Iva = Iva; 
    
    constructor(){
        
    }

    check(){
        console.log( 'Gas check OK' );
    }

    setRegion( region, zip ){
        if ( !region ){
            region = 'Lombardia';
        }

        if ( !zip ){
            this.trasporto = Trasporto.getCluster( region );
            this.oneri = Oneri.getCluster( region );
            this.accisa = Accisa.getCluster( region );
            this.addizionaleRegionale = AddizionaleRegionale.getCluster( region, 'base' );
        }
    }

    expenditure( consumption, region, zip=false, moltiplicator ){
        console.log( 'Gas expenditure', consumption, region, zip );

        this.setRegion( region, zip );

        //- Materia energia ---
            let materia = this.prezzoMateriaEnergia( consumption, moltiplicator );
        //- Traposto ---
            let trasporto = this.prezzoTrasporto( consumption );
        //- Oneri ---
            let oneri = this.prezzoOneri( consumption );
        //- Accisa, spesa ante imposta iva ---
            let accisa = this.prezzoAccisa( consumption );
        //- Accisa, spesa ante imposta iva ---
            let addizionaleRegionale = this.prezzoAddizionaleRegionale( consumption );

        console.log( 'Gas expenditure result', materia, trasporto, oneri, accisa, addizionaleRegionale );    
        return materia + trasporto + oneri + accisa + addizionaleRegionale;
    }
    
    prezzoMateriaEnergia( consumption, moltiplicator ){
        console.log( 'Gas prezzoMateriaEnergia this.g * moltiplicator + this.qvd.variabile' );
        console.log( 'Gas prezzoMateriaEnergia', this.g+' * '+moltiplicator+' + '+this.qvd.variabile+'='+this.g * moltiplicator + this.qvd.variabile );

        let price = this.g * moltiplicator + this.qvd.variabile;

        return this.priceScaglioni( consumption, price ) + this.qvd.fisso * Iva.intera;
    }

    prezzoTrasporto( consumption ){
        return this.priceScaglioni( consumption, this.trasporto.scaglioni ) + this.trasporto.fisso * Iva.intera;
    }

    prezzoOneri( consumption ){
        return this.priceScaglioni( consumption, this.oneri.scaglioni ) + this.oneri.fisso * Iva.intera;
    }

    prezzoAccisa( consumption ){
        return this.priceScaglioni( consumption, this.accisa.scaglioni );
    }

    prezzoAddizionaleRegionale( consumption ){
        return this.priceScaglioni( consumption, this.addizionaleRegionale.scaglioni );
    }

    //- scale function ---

    /*vatScaglioni( consumption, prezzoTemp ){
        console.log('priceScaglioni', prezzoTemp);

        let prezzo = [];
        if ( prezzoTemp.constructor === Array ){
            prezzo = prezzoTemp;
        } else {
            for (var i = 0; i < 6; i++) {
                prezzo.push( prezzoTemp );
            }
        }

        console.log('priceScaglioni', prezzo);

        let costo = 0;
        for (let i = this.scaglioni.length; i >= 0; i--) {
            if ( consumption > this.scaglioni[i] && typeof(prezzo[i]) !== 'undefined' ){
                let iva_step = ( Iva.soglia <= this.scaglioni[i] ) ? Iva.intera : Iva.ridotta;
                costo += (consumption - this.scaglioni[i]) * prezzo[i] * iva_step;
                consumption = this.scaglioni[i];
            }
        }
        return costo;
    }*/

    priceScaglioni( consumption, prezzoTemp ){
        console.log('priceScaglioni', prezzoTemp);

        let prezzo = [];
        if ( prezzoTemp.constructor === Array ){
            prezzo = prezzoTemp;
        } else {
            for (var i = 0; i < 6; i++) {
                prezzo.push( prezzoTemp );
            }
        }

        console.log('priceScaglioni', prezzo);

        let costo = 0;
        for (let i = this.scaglioni.length; i >= 0; i--) {
            if ( consumption > this.scaglioni[i] && typeof(prezzo[i]) !== 'undefined' ){
                let iva_step = ( Iva.soglia <= this.scaglioni[i] ) ? Iva.intera : Iva.ridotta;
                costo += (consumption - this.scaglioni[i]) * prezzo[i] * iva_step;
                consumption = this.scaglioni[i];
            }
        }
        return costo;
    }

}
export default new Gas();